const Catalogs = {
  Catalog: 'Catalog',
  CatalogDetail: 'CatalogDetail',
};
export { Catalogs };
